import collapseDirective from 'Site/directive/collapse';
import Editable from 'Site/component/Editable.vue';
import GoogleMap from 'Location/component/GoogleMap.vue';
import Impressions from 'Site/js/util/impressions';
import store from 'Site/js/store';
import User from 'Profile/component/User.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';
import { mapState } from 'vuex';
import Wall from 'Wall/component/Wall.vue';
import wallMediaMixin from 'Wall/js/mixins/media.page';
import WallPost from 'Wall/component/Post.vue';
import 'Wall/scss/wall-sidebar.scss';
import Events from '../../component/Events.vue';
import EventAttendees from '../../component/EventAttendees.vue';
import eventCreate from '../../component/eventCreate';
import eventHeader from '../../component/eventHeader';

function events() {
    Vue.use(VueRouter);
    const storeData = store.state.config.data;
    const routerConfig = storeData.router;
    const router = new VueRouter({
        mode: 'history',
        routes: [
            { path: `${routerConfig.page1Route}`, component: Events, props: { events: storeData.events, pages: storeData.totalPages } },
            {
                path: `${routerConfig.page2Route}(/${routerConfig.part.page}/)?:page?`,
                component: Events,
                props: { events: storeData.events, pages: storeData.totalPages }
            }
        ]
    });

    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        name: 'eventsPage',
        router,
        store,
        computed: mapState(['isMobile'])
    });
}
export default {
    events,
    'events-paginator': events,
    'events-view': () => {
        eventHeader();

        new Vue({ /* eslint no-new: 0 */
            el: '#event-body',
            name: 'eventBody',
            store,
            components: {
                Editable,
                EventAttendees,
                GoogleMap,
                User,
                Wall
            },
            computed: mapState({
                id: state => state.config.data.id,
                eventAjaxParams: state => ({ url: 'event', id: state.config.data.id }),
                t: state => state.t
            }),
            directives: {
                collapse: collapseDirective
            }
        });
    },
    'events-view-view-post': () => {
        eventHeader();

        new Vue({
            el: '#event-body',
            name: 'eventBody',
            store,
            components: {
                Editable,
                EventAttendees,
                GoogleMap,
                User,
                WallPost
            },
            computed: mapState({
                id: state => state.config.data.id,
                eventAjaxParams: state => ({ url: 'event', id: state.config.data.id }),
                t: state => state.t
            }),
            directives: {
                collapse: collapseDirective
            }
        });
    },
    'events-submit': () => {
        eventCreate();
    },
    'events-view-attendees': () => {
        eventHeader();

        new Vue({
            el: '#event-body',
            name: 'eventBody',
            store,
            computed: mapState({
                attendees: state => state.config.data.attendees,
                t: state => state.t
            }),
            components: {
                EventAttendees,
                User
            },
            methods: {
                attendeeChange(params) {
                    if (params.action === 'unban' || params.action === 'approve') {
                        this.$store.state.config.data.attendees.push(params.attendee);
                    }
                }
            }
        });
    },
    'events-view-media': () => {
        eventHeader();

        new Vue({
            el: '#event-body',
            name: 'eventBody',
            store,
            data: {
                type: 'event'
            },
            mixins: [wallMediaMixin]
        });

        new Impressions('.impress-image', 'Event');
    }
};
